import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    FilledInput,
    FormControl,
    FormControlLabel,
    InputAdornment,
} from "@mui/material";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import { Search } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

function PoolcheckBoxesDialog({ items, setPoolModel, poolModel, getCheckBoxData, defaultChecked, getSelectedCheckBoxes }) {

    const getHighlightedText = (text, highlight) => {
        // Split on highlight term and include term into parts, ignore case
        const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
        return <span> {parts.map((part, i) =>
            <span key={i} style={part?.toLowerCase() === highlight?.toLowerCase() ? { color: '#98BCC4' } : {}}>
                {part}
            </span>)
        } </span>;
    }

    const [selectedCheckBoxes, setSelectedCheckboxes] = useState(0);

    const [searchText, setSearchText] = useState("");

    const [filteredItems, setFilteredItems] = useState("");

    const [checkedItems, setCheckedItems] = useState(defaultChecked && defaultChecked.length ? defaultChecked.reduce((acc, current) => {
        acc[current] = true;
        return acc;
    }, {}) : {});

    const handleCheckboxChange = (event) => {
        // Updating the state by computing the new state based on the previous one
        setCheckedItems({
            ...checkedItems,
            [event.target.name]: event.target.checked,
        });

        setSelectedCheckboxes(getSelectedCheckboxIds().length);
    };


    useEffect(() => {
        setTimeout(() => {
            getSelectedCheckBoxes(getSelectedCheckboxIds());
        }, [2000])
    }, [])



    // To get the IDs of selected checkboxes
    const getSelectedCheckboxIds = () => {
        return Object.entries(checkedItems)
            .filter(([key, value]) => value)
            .map(([key]) => key);
    };

    const handleSearchTextChange = (e) => {
        let text = e.target.value;
        setSearchText(text);

        setFilteredItems(
            items.filter((item) => {
                return (
                    item.eqName.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.eqId.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
                    item.brandName
                        .toLocaleLowerCase()
                        .includes(text.toLocaleLowerCase()) ||
                    item.typIdentifier
                        .toLocaleLowerCase()
                        .includes(text.toLocaleLowerCase())
                );
            })
        );
    };


    const handleSubmitPoolDialog = () => {
        setPoolModel(false);
        getSelectedCheckBoxes(getSelectedCheckboxIds());
        getCheckBoxData(checkedItems);
    }

    const handleClose = () => {
        setPoolModel(false);
        setCheckedItems(defaultChecked && defaultChecked.length ? defaultChecked.reduce((acc, current) => {
            acc[current] = true;
            return acc;
        }, {}) : {})
    }


    return <div>
        <Dialog
            onClose={handleClose}
            open={poolModel}
            fullWidth
        >
            <DialogContent>
                <div className="searchField">
                    <FormControl fullWidth variant="filled">
                        <FilledInput
                            value={searchText}
                            onChange={handleSearchTextChange}
                            sx={{ background: "#FFFFFF !important", paddingLeft: 0 }}
                            id="filled-adornment-weight"
                            placeholder="Suchbegriff eingeben..."
                            endAdornment={
                                <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            }
                            aria-describedby="filled-weight-helper-text"
                            inputProps={{
                                "aria-label": "weight",
                            }}
                        />
                    </FormControl>

                    {/* <Divider orientation="horizontal" sx={{ margin: "28px 0px" }} /> */}

                    <div className="searchStats">
                        {searchText.length
                            ? filteredItems.length +
                            " Suchergebnisse – " +
                            (getSelectedCheckboxIds().length) +
                            " ausgewählt"
                            : (items.length
                                + " Einträge - " + (getSelectedCheckboxIds().length) + " ausgewählt")}
                    </div>

                    <div className="checkboxesWrapper" >
                        {(searchText.length ? filteredItems : items).map((item,key) => (
                            <>
                            { item.className === "eqUnlinked" || item.className === "eqLast" ? <div className={item.className}> <div id="line-lr"></div> <div className="label">Nicht verknüpfte Geräte</div>  <div id="line-lr"></div>  </div> : ""}
                                <FormControlLabel
                                sx={{ width: "100%"}}
                                    control={
                                        <Checkbox
                                            checked={checkedItems[item.id] || false}
                                            onChange={handleCheckboxChange}
                                            name={item.id}
                                            inputProps={{ "data-testid": "chkbx_create_area_select_equipment-"+key}}
                                        />
                                    }
                                    label={
                                        <div className="poolCheckBoxes">
                                            <div className="eqName">{ item.icon ? <span style={{ marginRight:"8px"}}>{item.icon}</span>  : ""} {getHighlightedText(item.eqName, searchText)}  </div>
                                            <div className="eqSubname">
                                                {getHighlightedText(item.eqId, searchText)}  • {getHighlightedText(item.brandName, searchText)} • {getHighlightedText(item.typIdentifier, searchText)}
                                            </div>
                                        </div>
                                    }
                                    key={item.id}
                                />
                                <Divider orientation="horizontal" className={item.className} />
                            </>
                        ))}
                    </div>

                    {/* <div className="checkboxesWrapper">
                        {(searchText.length ? filteredItems : items).map((item) => (
                            <>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkedItems[item.id] || false}
                                            onChange={handleCheckboxChange}
                                            name={item.id}
                                        />
                                    }
                                    label={
                                        <div className="poolCheckBoxes">
                                            <div className="eqName">{getHighlightedText(item.eqName, searchText)}</div>
                                            <div className="eqSubname">
                                                {getHighlightedText(item.eqId, searchText)}  • {getHighlightedText(item.brandName, searchText)} • {getHighlightedText(item.typIdentifier, searchText)}
                                            </div>
                                        </div>
                                    }
                                    key={item.id}
                                />
                                <Divider orientation="horizontal" />
                            </>
                        ))}
                    </div> */}

                </div>
            </DialogContent>

            <DialogActions style={{ padding: " 0px 24px 24px 0px"}}>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    sx={{ border: "none" }}
                    data-testid="btn_create_area_select_equipment_close"
                >
                    Abbrechen
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmitPoolDialog}
                    data-testid="btn_create_area_select_equipment_confirm"
                >
                    Auswahl speichern
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}

export default PoolcheckBoxesDialog;